import api from './api';

const MasterJobService = {
  // Obtener todos los master jobs con paginación y filtros
  getAllMasterJobs: async (page = 1, limit = 10, search = '', category = '', sortBy = 'kode_pekerjaan', sortOrder = 'asc') => {
    try {
      const response = await api.get('/master-jobs', { 
        params: { page, limit, search, category, sortBy, sortOrder } 
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : { message: 'Network error' };
    }
  },

  // Obtener un master job por ID
  getMasterJobById: async (id) => {
    try {
      const response = await api.get(`/master-jobs/${id}`);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : { message: 'Network error' };
    }
  },

  // Crear un nuevo master job
  createMasterJob: async (masterJobData) => {
    try {
      const response = await api.post('/master-jobs', masterJobData);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : { message: 'Network error' };
    }
  },

  // Actualizar un master job existente
  updateMasterJob: async (id, masterJobData) => {
    try {
      const response = await api.put(`/master-jobs/${id}`, masterJobData);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : { message: 'Network error' };
    }
  },

  // Eliminar un master job
  deleteMasterJob: async (id) => {
    try {
      const response = await api.delete(`/master-jobs/${id}`);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : { message: 'Network error' };
    }
  },

  // Importar master jobs desde archivo CSV
  importMasterJobs: async (formData) => {
    try {
      // Utilizamos FormData para el upload del archivo
      const response = await api.post('/master-jobs/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : { message: 'Network error' };
    }
  },

  // Obtener categorías únicas para los filtros
  getCategories: async () => {
    try {
      const response = await api.get('/master-jobs/categories/all');
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : { message: 'Network error' };
    }
  },

  // Función para generar plantilla de Excel (client-side)
  generateExcelTemplate: () => {
    return {
      headers: [
        'Kode Pekerjaan',
        'Nama Pekerjaan',
        'Kategori/Sub Divisi',
        'Volume Default',
        'Satuan (BoQ)',
        'Tipe Input'
      ],
      sampleData: [
        {
          'Kode Pekerjaan': '1.1.1.01',
          'Nama Pekerjaan': 'Pekerjaan Bowplank',
          'Kategori/Sub Divisi': 'Pondasi Slab',
          'Volume Default': 25.0,
          'Satuan (BoQ)': 'm3',
          'Tipe Input': 'manual'
        },
        {
          'Kode Pekerjaan': '1.2.1.01',
          'Nama Pekerjaan': 'Assembly Wallframe',
          'Kategori/Sub Divisi': 'Dinding',
          'Volume Default': 0,
          'Satuan (BoQ)': 'unit',
          'Tipe Input': 'manual'
        }
      ]
    };
  }
};

export default MasterJobService; 